// Third party libs/components
import React from 'react';
import { Helmet } from 'react-helmet';

// Components
import SearchResultsHeader from '@components/SearchResultsHeader';
import FlightResultSection from '@components/FlightResultSection';
import SharedFlight from '@components/SharedFlight';
import SearchLoading from './SearchLoading';
import SearchResultsAircraft from '../SearchResultsAircraft';
import LoginModal from '@components/LoginModal';
// Utils
import { translate as t } from '@utils/translate';
import { getCookie, setCookie } from '@utils/cookies.helper';
// Services
import useViewModel from './useViewModel';

import { useState } from 'react';
import { getUserIndicated, getUserStorage } from '@/services/auth';

const Search = () => {
  const {
    searchResults,
    searchFilteredResults,
    searchHeaderProps,
    routeParams,
    selectedModelId,
    handleSelectAircraft,
    selectRoute,
  } = useViewModel();

  let isPartnerCode = false;
  const xpublic = getCookie('x-public');
  const [loginOpened, setLogin] = useState(true);

  // widget feature to add partner code to the proposal info and send it in the message
  const searchPartnerCode = new URLSearchParams(window.location.search);
  let partnerCode =
    searchPartnerCode.get('partnerCode') || getCookie('partnerCode');

  if (!partnerCode && xpublic) {
    const { id } = getUserStorage();
    if (id) {
      try {
        getUserIndicated(id)
          .then(res => res)
          .then(res => {
            if (res) {
              setCookie('partnerCode', res.partnerCode);
              partnerCode = res.partnerCode;
            }
          });
      } catch (error) {
        console.warn('Error getting user indicated partner code:', error);
      }
    }
  }

  if (partnerCode && !xpublic) {
    setCookie('partnerCode', partnerCode);
    isPartnerCode = true;
  }

  if (!searchResults.routes) {
    return (
      <SearchLoading
        origin={searchHeaderProps.origin.name}
        destination={searchHeaderProps.destination.name}
      />
    );
  }

  if (
    routeParams.flightType === 'flights' &&
    searchFilteredResults.routes?.length
  ) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <SearchResultsHeader {...searchHeaderProps} />
        <SharedFlight
          searchParams={routeParams}
          flights={searchFilteredResults.routes}
        />
      </>
    );
  } else if (routeParams.flightType !== 'flights') {
    return (
      <>
        {isPartnerCode && loginOpened && (
          <LoginModal
            partnerCode={partnerCode}
            defaultStep={1}
            closeModal={() => {
              setLogin(false);
            }}
            hideCloseButton={true}
          />
        )}
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>

        <SearchResultsHeader {...searchHeaderProps} />

        {!searchFilteredResults?.routes?.length || true === 0 ? (
          <h1
            style={{
              marginTop: '160px',
              display: 'grid',
              width: '100%',
              height: '500px',
              placeContent: 'center',
              textAlign: 'center',
            }}
          >
            {t('noResultFound')}
          </h1>
        ) : null}
        {searchFilteredResults.routes &&
        searchFilteredResults.routes.length === 1 ? (
          <SearchResultsAircraft
            data={searchFilteredResults}
            modelId={selectedModelId}
            onSelectAircraft={handleSelectAircraft}
          />
        ) : (
          <>
            {searchFilteredResults.routes &&
              searchFilteredResults.routes.map((route, index) => (
                <FlightResultSection
                  key={index}
                  initiallyOpened={searchFilteredResults.routes.length === 1}
                  originSpot={route.originSpot}
                  destinationSpot={route.destinationSpot}
                  flightsList={route.aircraftModels || [route.aircraft]}
                  mappedRouteIndex={route.mappedIndex}
                  onSelect={selectRoute}
                />
              ))}
          </>
        )}
      </>
    );
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      <SearchResultsHeader {...searchHeaderProps} />

      <h1
        style={{
          marginTop: '160px',
          display: 'grid',
          width: '100%',
          height: '500px',
          placeContent: 'center',
          textAlign: 'center',
        }}
      >
        {t('noResultFound')}
      </h1>
    </>
  );
};

export default Search;
